import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-neural-network',
  templateUrl: './neural-network.component.html',
  styleUrls: ['./neural-network.component.scss']
})
export class NeuralNetworkComponent implements OnInit {

  @Input() canvasHeight = 400;
  @Input() canvasWidth = 400;
  @Input() shapeSpacing = 70;

  canvasRender: number[] = [window.innerWidth, window.innerHeight];

  constructor() { }

  ngOnInit() {

    const networks = {
      1: {
        type: 'rectangle',
        fill: 'none',
        text: [{
          direction: 'top',
          fontSize: 11,
          text: 'Pasivos',
          align: 'left',
        }, {
          direction: 'bottom',
          fontSize: 11,
          text: '$7.407.000.000',
          align: 'left',
        }]
      },
      2: {
        type: 'rectangle',
        fill: 'solid',
        text: [{
          direction: 'top',
          text: 'Activos',
          align: 'left',
          fontSize: 11,
        }, {
          direction: 'bottom',
          text: '$100.000.000',
          align: 'left',
          fontSize: 11,
        }]
      },
      3: {
        type: 'rectangle',
        fill: 'none',
        text: [{
          direction: 'top',
          text: 'Eder',
          align: 'left',
          fontSize: 11,
        }, {
          direction: 'bottom',
          text: '$1.500.000',
          align: 'left',
          fontSize: 11,
        }]
      },
      4: {
        type: 'circle',
        fill: 'solid',
        text: [{
          direction: 'bottom',
          text: 'Description for circle',
          align: 'left',
          fontSize: 11,
        }]
      },
      5: {
        type: 'rectangle',
        fill: 'none',
        text: [{
          direction: 'top',
          text: 'Total: ',
          align: 'left',
          fontSize: 12,
        }, {
          direction: 'bottom',
          text: '$1.500.000.000',
          align: 'left',
          fontSize: 12,
        }]
      }
    };

    const canvas: HTMLCanvasElement = document.querySelector("#tutorial") as HTMLCanvasElement;
    setTimeout(() => {
      if (canvas.getContext) {
        const ctx = canvas.getContext("2d");
        // shapes: Listado de figuras
        const shapes: Path2D[] = [];
        // shapeAttributes: Atributos de las figuras
        const shapeAttributes: any[] = [];

        Object.keys(networks).forEach((elm: any, idx: number) => {
          // element: Red
          const element = networks[elm];
          // maxTextLength: Máxima longitud de texto
          const maxTextLength = element.text.reduce((pre: number, cur: any) => {
            // textLength: Cantidad de caracteres
            const textLength = cur.text.length;
            // textWidth: Caracteres por tamaño
            const textWidth = textLength * (cur.fontSize || this.shapeSpacing);
            // ↓ Devuelve el mayor tamaño
            return textWidth > pre ? textWidth : pre;
          }, 0);

          let topSpacing = shapeAttributes[shapeAttributes.length - 1] ? shapeAttributes[shapeAttributes.length - 1].y : this.shapeSpacing;
          // leftSpacing: Espacio entre figuras
          let leftSpacing = shapeAttributes.slice(0, idx)
            .filter((el) => el.y === topSpacing)
            .reduce((pre: number, cur: any) => pre + cur.width + this.shapeSpacing, 0);
          // console.log(idx, shapeAttributes.slice(0, idx).filter((el) => el.y === (shapeAttributes[shapeAttributes.length - 1] ? shapeAttributes[shapeAttributes.length - 1].y : this.shapeSpacing)), leftSpacing);

          if ((this.shapeSpacing + leftSpacing) + maxTextLength > this.canvasRender[0]) {
            topSpacing += (this.shapeSpacing + 50); leftSpacing = 0;
          }

          shapeAttributes[idx] = { width: maxTextLength, height: topSpacing, x: (this.shapeSpacing + leftSpacing), y: topSpacing };
          // ↓ Posicionamiento de las figuras
          shapes[idx] = new Path2D();

          switch (element.type) {
            case "rectangle":
              shapes[idx].rect(this.shapeSpacing + leftSpacing, topSpacing, maxTextLength, 50);
              break;
            case "circle":
              shapes[idx].arc(this.shapeSpacing + leftSpacing + (maxTextLength / 2), topSpacing, (maxTextLength / 2), 0, 2 * Math.PI);
              break;
            default:
              shapes[idx].rect(this.shapeSpacing + leftSpacing, topSpacing, maxTextLength, 50);
              break;
          }


          switch (element.fill) {
            case "solid":
              ctx.fill(shapes[idx]);
              break;
            case "none":
              ctx.stroke(shapes[idx]);
              break;
            default:
              ctx.stroke(shapes[idx]);
              break;
          }
        });


      } else {
      }
    }, 100);
  }

}
